import { clsx } from 'clsx';

import { BurgerBar } from './BurgerBar';

type CloseButtonProps = {
  isOpen: boolean;
  onClick?: () => void;
  className?: string;
};

export const BurgerButton = ({
  isOpen,
  onClick,
  className,
}: CloseButtonProps) => {
  return (
    <button
      name='burger-button'
      aria-label='Open/close menu button'
      onClick={onClick}
      className={clsx(
        'burger-button button relative flex h-8 w-9 flex-col ml-1 gap-1.5 sm:h-5 sm:w-5',
        { 'burger-button-open': isOpen },
        className
      )}
      data-testid='burger-button'
    >
      <BurgerBar isOpen={isOpen} position='top' />
      <BurgerBar isOpen={isOpen} position='middle' />
      <BurgerBar isOpen={isOpen} position='bottom' />
    </button>
  );
};

export default BurgerButton;
